/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "vakar",
      "-2": "aizvakar",
      "0": "šodien",
      "1": "rīt",
      "2": "parīt",
      "future": {
        "one": "pēc {0} dienas",
        "other": "pēc {0} dienām",
        "zero": "pēc {0} dienām"
      },
      "past": {
        "one": "pirms {0} dienas",
        "other": "pirms {0} dienām",
        "zero": "pirms {0} dienām"
      }
    },
    "day-narrow": {
      "-1": "vakar",
      "-2": "aizvakar",
      "0": "šodien",
      "1": "rīt",
      "2": "parīt",
      "future": {
        "one": "pēc {0} d.",
        "other": "pēc {0} d.",
        "zero": "pēc {0} d."
      },
      "past": {
        "one": "pirms {0} d.",
        "other": "pirms {0} d.",
        "zero": "pirms {0} d."
      }
    },
    "day-short": {
      "-1": "vakar",
      "-2": "aizvakar",
      "0": "šodien",
      "1": "rīt",
      "2": "parīt",
      "future": {
        "one": "pēc {0} d.",
        "other": "pēc {0} d.",
        "zero": "pēc {0} d."
      },
      "past": {
        "one": "pirms {0} d.",
        "other": "pirms {0} d.",
        "zero": "pirms {0} d."
      }
    },
    "hour": {
      "0": "šajā stundā",
      "future": {
        "one": "pēc {0} stundas",
        "other": "pēc {0} stundām",
        "zero": "pēc {0} stundām"
      },
      "past": {
        "one": "pirms {0} stundas",
        "other": "pirms {0} stundām",
        "zero": "pirms {0} stundām"
      }
    },
    "hour-narrow": {
      "0": "šajā stundā",
      "future": {
        "one": "pēc {0} h",
        "other": "pēc {0} h",
        "zero": "pēc {0} h"
      },
      "past": {
        "one": "pirms {0} h",
        "other": "pirms {0} h",
        "zero": "pirms {0} h"
      }
    },
    "hour-short": {
      "0": "šajā stundā",
      "future": {
        "one": "pēc {0} st.",
        "other": "pēc {0} st.",
        "zero": "pēc {0} st."
      },
      "past": {
        "one": "pirms {0} st.",
        "other": "pirms {0} st.",
        "zero": "pirms {0} st."
      }
    },
    "minute": {
      "0": "šajā minūtē",
      "future": {
        "one": "pēc {0} minūtes",
        "other": "pēc {0} minūtēm",
        "zero": "pēc {0} minūtēm"
      },
      "past": {
        "one": "pirms {0} minūtes",
        "other": "pirms {0} minūtēm",
        "zero": "pirms {0} minūtēm"
      }
    },
    "minute-narrow": {
      "0": "šajā minūtē",
      "future": {
        "one": "pēc {0} min",
        "other": "pēc {0} min",
        "zero": "pēc {0} min"
      },
      "past": {
        "one": "pirms {0} min",
        "other": "pirms {0} min",
        "zero": "pirms {0} min"
      }
    },
    "minute-short": {
      "0": "šajā minūtē",
      "future": {
        "one": "pēc {0} min.",
        "other": "pēc {0} min.",
        "zero": "pēc {0} min."
      },
      "past": {
        "one": "pirms {0} min.",
        "other": "pirms {0} min.",
        "zero": "pirms {0} min."
      }
    },
    "month": {
      "-1": "pagājušajā mēnesī",
      "0": "šajā mēnesī",
      "1": "nākamajā mēnesī",
      "future": {
        "one": "pēc {0} mēneša",
        "other": "pēc {0} mēnešiem",
        "zero": "pēc {0} mēnešiem"
      },
      "past": {
        "one": "pirms {0} mēneša",
        "other": "pirms {0} mēnešiem",
        "zero": "pirms {0} mēnešiem"
      }
    },
    "month-narrow": {
      "-1": "pag. mēn.",
      "0": "šajā mēn.",
      "1": "nāk. mēn.",
      "future": {
        "one": "pēc {0} mēn.",
        "other": "pēc {0} mēn.",
        "zero": "pēc {0} mēn."
      },
      "past": {
        "one": "pirms {0} mēn.",
        "other": "pirms {0} mēn.",
        "zero": "pirms {0} mēn."
      }
    },
    "month-short": {
      "-1": "pag. mēn.",
      "0": "šajā mēn.",
      "1": "nāk. mēn.",
      "future": {
        "one": "pēc {0} mēn.",
        "other": "pēc {0} mēn.",
        "zero": "pēc {0} mēn."
      },
      "past": {
        "one": "pirms {0} mēn.",
        "other": "pirms {0} mēn.",
        "zero": "pirms {0} mēn."
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "pēdējais ceturksnis",
      "0": "šis ceturksnis",
      "1": "nākamais ceturksnis",
      "future": {
        "one": "pēc {0} ceturkšņa",
        "other": "pēc {0} ceturkšņiem",
        "zero": "pēc {0} ceturkšņiem"
      },
      "past": {
        "one": "pirms {0} ceturkšņa",
        "other": "pirms {0} ceturkšņiem",
        "zero": "pirms {0} ceturkšņiem"
      }
    },
    "quarter-narrow": {
      "-1": "pēdējais ceturksnis",
      "0": "šis ceturksnis",
      "1": "nākamais ceturksnis",
      "future": {
        "one": "pēc {0} cet.",
        "other": "pēc {0} cet.",
        "zero": "pēc {0} cet."
      },
      "past": {
        "one": "pirms {0} cet.",
        "other": "pirms {0} cet.",
        "zero": "pirms {0} cet."
      }
    },
    "quarter-short": {
      "-1": "pēdējais ceturksnis",
      "0": "šis ceturksnis",
      "1": "nākamais ceturksnis",
      "future": {
        "one": "pēc {0} cet.",
        "other": "pēc {0} cet.",
        "zero": "pēc {0} cet."
      },
      "past": {
        "one": "pirms {0} cet.",
        "other": "pirms {0} cet.",
        "zero": "pirms {0} cet."
      }
    },
    "second": {
      "0": "tagad",
      "future": {
        "one": "pēc {0} sekundes",
        "other": "pēc {0} sekundēm",
        "zero": "pēc {0} sekundēm"
      },
      "past": {
        "one": "pirms {0} sekundes",
        "other": "pirms {0} sekundēm",
        "zero": "pirms {0} sekundēm"
      }
    },
    "second-narrow": {
      "0": "tagad",
      "future": {
        "one": "pēc {0} s",
        "other": "pēc {0} s",
        "zero": "pēc {0} s"
      },
      "past": {
        "one": "pirms {0} s",
        "other": "pirms {0} s",
        "zero": "pirms {0} s"
      }
    },
    "second-short": {
      "0": "tagad",
      "future": {
        "one": "pēc {0} sek.",
        "other": "pēc {0} sek.",
        "zero": "pēc {0} sek."
      },
      "past": {
        "one": "pirms {0} sek.",
        "other": "pirms {0} sek.",
        "zero": "pirms {0} sek."
      }
    },
    "week": {
      "-1": "pagājušajā nedēļā",
      "0": "šajā nedēļā",
      "1": "nākamajā nedēļā",
      "future": {
        "one": "pēc {0} nedēļas",
        "other": "pēc {0} nedēļām",
        "zero": "pēc {0} nedēļām"
      },
      "past": {
        "one": "pirms {0} nedēļas",
        "other": "pirms {0} nedēļām",
        "zero": "pirms {0} nedēļām"
      }
    },
    "week-narrow": {
      "-1": "pag. ned.",
      "0": "šajā ned.",
      "1": "nāk. ned.",
      "future": {
        "one": "pēc {0} ned.",
        "other": "pēc {0} ned.",
        "zero": "pēc {0} ned."
      },
      "past": {
        "one": "pirms {0} ned.",
        "other": "pirms {0} ned.",
        "zero": "pirms {0} ned."
      }
    },
    "week-short": {
      "-1": "pag. ned.",
      "0": "šajā ned.",
      "1": "nāk. ned.",
      "future": {
        "one": "pēc {0} ned.",
        "other": "pēc {0} ned.",
        "zero": "pēc {0} ned."
      },
      "past": {
        "one": "pirms {0} ned.",
        "other": "pirms {0} ned.",
        "zero": "pirms {0} ned."
      }
    },
    "year": {
      "-1": "pagājušajā gadā",
      "0": "šajā gadā",
      "1": "nākamajā gadā",
      "future": {
        "one": "pēc {0} gada",
        "other": "pēc {0} gadiem",
        "zero": "pēc {0} gadiem"
      },
      "past": {
        "one": "pirms {0} gada",
        "other": "pirms {0} gadiem",
        "zero": "pirms {0} gadiem"
      }
    },
    "year-narrow": {
      "-1": "pag. gadā",
      "0": "šajā g.",
      "1": "nāk. gadā",
      "future": {
        "one": "pēc {0} g.",
        "other": "pēc {0} g.",
        "zero": "pēc {0} g."
      },
      "past": {
        "one": "pirms {0} g.",
        "other": "pirms {0} g.",
        "zero": "pirms {0} g."
      }
    },
    "year-short": {
      "-1": "pag. gadā",
      "0": "šajā g.",
      "1": "nāk. gadā",
      "future": {
        "one": "pēc {0} g.",
        "other": "pēc {0} g.",
        "zero": "pēc {0} g."
      },
      "past": {
        "one": "pirms {0} g.",
        "other": "pirms {0} g.",
        "zero": "pirms {0} g."
      }
    }
  },
  "locale": "lv"
})
}
